export default __webpack_public_path__ + "static/media/volkihar-banner-large.4ba445cf.jpg";